import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Building2, DollarSign, Clock, ArrowRight } from 'lucide-react';
import { formatTimeAgo } from '../utils/jobData';

export default function JobCard({ job }) {
  // Destructure the CLEAN fields created by normalizeJob
  const { 
    id, 
    title, 
    company, 
    location, 
    salary, 
    type, 
    postedAt, 
    logo 
  } = job;

  return (
    <Link 
      to={`/job/${id}`}
      className="group block bg-white rounded-2xl border border-slate-200 p-5 hover:border-blue-300 hover:shadow-xl hover:shadow-blue-500/5 transition-all duration-300"
    >
      <div className="flex flex-col md:flex-row md:items-center gap-5">
        
        {/* Company Logo */}
        <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center overflow-hidden group-hover:scale-105 transition-transform">
          {logo ? (
            <img src={logo} alt={company} className="w-full h-full object-contain p-2" />
          ) : (
            <Building2 className="text-slate-300" size={28} />
          )}
        </div>

        {/* Job Info */}
        <div className="flex-grow">
          <h3 className="text-lg font-bold text-slate-900 group-hover:text-blue-600 transition-colors leading-tight mb-1">
            {title}
          </h3>
          
          <div className="flex flex-wrap items-center gap-y-2 gap-x-4 text-sm font-medium text-slate-500">
            <span className="flex items-center gap-1.5">
              <Building2 size={14} className="text-slate-400" />
              {company}
            </span>
            <span className="flex items-center gap-1.5">
              <MapPin size={14} className="text-slate-400" />
              {location.full} 
            </span>
            <span className="flex items-center gap-1.5 text-blue-600 bg-blue-50 px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-wider">
              {type}
            </span>
          </div>
        </div>

        {/* Salary & Meta */}
        <div className="flex flex-row md:flex-col items-center md:items-end justify-between md:justify-center gap-2 pt-4 md:pt-0 border-t md:border-t-0 border-slate-100">
          <div className="flex items-center gap-1 text-slate-900 font-bold text-sm">
            <DollarSign size={14} className="text-green-600" />
            <span>{salary}</span>
          </div>
          <div className="flex items-center gap-1 text-[11px] text-slate-400 font-medium">
            <Clock size={12} />
            {formatTimeAgo(postedAt)}
          </div>
        </div>

        {/* Hover Arrow (Desktop only) */}
        <div className="hidden md:flex items-center justify-center w-10 h-10 rounded-full bg-slate-50 text-slate-300 group-hover:bg-blue-600 group-hover:text-white transition-all">
          <ArrowRight size={20} />
        </div>
      </div>
    </Link>
  );
}